// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconEwiEwiColoredDarkQuestion_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7" fill="#828D9E"/>
  <path d="M11 6.14494C11 4.68411 9.6426 3.5 7.96861 3.5 6.50648 3.5 5.28529 4.40375 5 5.60621L6.72955 6.14494C6.72955 5.54878 7.28584 5.06395 7.96843 5.06395 8.65156 5.06395 9.20732 5.54878 9.20732 6.14494 9.20732 6.54754 8.95309 6.8995 8.57787 7.08532 7.98491 7.38696 7.52111 7.86017 7.27202 8.42536 7.18787 8.61799 7.1287 8.82069 7.09769 9.03159H7.09929V9.5H8.93112V9.03159H8.92776C9.02626 8.77222 9.23442 8.55636 9.50459 8.42536H9.50282C10.3989 7.96624 11 7.11706 11 6.14494ZM9 10.5H7V12.5H9V10.5Z" fill="#1A2329"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" fill="#828D9E"/>
  <path d="M16.7142 8.50594C16.7142 6.21036 14.5812 4.34961 11.9506 4.34961 9.65297 4.34961 7.73396 5.76978 7.28564 7.65937L10.0035 8.50594C10.0035 7.56912 10.8777 6.80725 11.9503 6.80725 13.0238 6.80725 13.8971 7.56912 13.8971 8.50594 13.8971 9.1386 13.4976 9.69169 12.908 9.98368V9.98515C11.9762 10.4592 11.0883 11.2013 10.6969 12.0895 10.5646 12.3922 10.4285 12.7306 10.4285 13.0421V13.7782H13.5714V12.7306C13.6999 12.392 13.8691 12.3156 14.166 12.1814 14.2265 12.1541 14.2924 12.1243 14.3643 12.0895H14.3615C15.7696 11.368 16.7142 10.0336 16.7142 8.50594ZM13.5714 15.8564H10.4285V18.9992H13.5714V15.8564Z" fill="#1A2329"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z" fill="#828D9E"/>
  <path d="M21 11.8489C21 9.17082 18.7377 7 15.9477 7 13.5108 7 11.4755 8.65683 11 10.8613L13.8826 11.8489C13.8826 10.756 14.8097 9.86717 15.9474 9.86717 17.0859 9.86717 18.0122 10.756 18.0122 11.8489 18.0122 12.587 17.5885 13.2323 16.9631 13.5729V13.5746C15.9749 14.1276 15.2018 14.9934 14.7867 16.0296 14.6464 16.3827 14.5478 16.7543 14.4962 17.141H14.4988V17.9997H17.5519V17.141H17.5463C17.7104 16.6655 18.0574 16.2698 18.5077 16.0296H18.5047C19.9982 15.1879 21 13.6311 21 11.8489ZM17.4633 21H14.4318V24H17.4633V21Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconEwiEwiColoredDarkQuestion is a generated icon component.
 */
let IconEwiEwiColoredDarkQuestion = IconEwiEwiColoredDarkQuestion_1 = class IconEwiEwiColoredDarkQuestion extends IconBaseElement {
    render() {
        return html `${IconEwiEwiColoredDarkQuestion_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconEwiEwiColoredDarkQuestion.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconEwiEwiColoredDarkQuestion = IconEwiEwiColoredDarkQuestion_1 = __decorate([
    customElement('zui-icon-ewi-ewi-colored-dark-question')
], IconEwiEwiColoredDarkQuestion);
export { IconEwiEwiColoredDarkQuestion };
